// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/async/" + chunkId + "." + {"883": "3716ef49","951": "98da80c3","984": "74944c55",}[chunkId] + ".css"
}